import { FocusContext, useFocusable } from "@noriginmedia/norigin-spatial-navigation";
import { useCallback, useEffect, useRef, useState } from "react";
import { LOCAL_STORAGE_KEY, PLAYER } from "../../../constant";
import { getPage, removeDevice } from "../../../Api/api";
import 'material-symbols';
import { utility } from "../../../utility/utility";
import { useNavigate } from "react-router";
import crown from '../../../images/crown.png';
import { useDispatch, useSelector } from "react-redux";
import { resetApplication, setPrevPath, setUser } from "../../../redux/applicationSlice";
import Smiley from "../../profile/components/Smiley";
function MenuItem({ hasFocusedChild, onClick, onMouseFocus, menuSettings, item, index, setSelectedMenu, currentPage }) {
    const { ref, focused } = useFocusable({
        onArrowPress: (direction) => {
            if (direction == 'left') {
                return false;
            } else {
                return true;
            }
        },
    });
    const [onMenuItemMouseFocus, setOnMenuItemMouseFocus] = useState(false);
    console.log(currentPage)
    //if focused
    useEffect(() => {
        if (focused || onMenuItemMouseFocus) {
            setSelectedMenu(item);
        }
    }, [focused, onMenuItemMouseFocus]);

    let isSelectedMenu = currentPage._id == item._id;
    return <div
        onMouseEnter={() => setOnMenuItemMouseFocus(true)}
        onMouseLeave={() => setOnMenuItemMouseFocus(false)}
        onClick={onClick}
        key={index} style={{
            width: "auto",
            height: "51px",
            backgroundColor: "transparent",
            borderColor: "white",
            borderStyle: "solid",
            borderWidth: `${(focused || onMenuItemMouseFocus) ? '2px' : 0}`,
            scale: `${(focused || onMenuItemMouseFocus) ? 1.1 : 1}`,
            boxSizing: "border-box",
            borderRadius: "7px",
            marginBottom: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            marginLeft: "15px",
            marginRight: "15px",
            transition: "all 0.1s ease-in-out"
        }} id={item._id} ref={ref} ><span className={`material-symbols-outlined`} style={{
            fontSize: (parseInt(menuSettings?.iconSize) + 7) + "px"
                ?? "25px", color: isSelectedMenu ? menuSettings?.iconSelectedColor : menuSettings?.iconColor ?? "white"
        }} >{item.IconUrl}</span> {(hasFocusedChild || onMouseFocus) && <span style={{ color: isSelectedMenu ? menuSettings?.iconSelectedColor : menuSettings?.color ?? "white", marginLeft: "10px" }}>{item?.displayName ?? ""}</span>}</div>;
}

const NmLogo = ({ src, width, showCrown }) => <div>{showCrown && <img className={"crown focus"} src={crown} />}<img src={src} style={{
    width: width * 5,
    marginBottom: " 10px",
    padding: "0 10px",
    objectFit: "contain",
}} /></div>;

export default function Menu({ focusKey: focusKeyParam, ottSetting, menu, setCurrentPage, currentPage }) {
    const {
        ref,
        focusSelf,
        hasFocusedChild,
        focusKey
        // setFocus, -- to set focus manually to some focusKey
        // navigateByDirection, -- to manually navigate by direction
        // pause, -- to pause all navigation events
        // resume, -- to resume all navigation events
        // updateAllLayouts, -- to force update all layouts when needed
        // getCurrentFocusKey -- to get the current focus key
    } = useFocusable({
        focusable: true,
        saveLastFocusedChild: false,
        trackChildren: true,
        autoRestoreFocus: true,
        isFocusBoundary: false,
        focusKey: focusKeyParam,
        preferredChildFocusKey: null,
        onArrowPress: () => true,
    });
    const selectedMenu = useRef({});
    const isLoginRef = useRef(utility.getValue(LOCAL_STORAGE_KEY.user) !== null);
    const setSelectedMenu = (menu) => {
        selectedMenu.current = menu;
        console.log(menu);
        document.getElementById(menu._id)?.scrollIntoView({ behavior: "smooth", block: "center" });
    }

    const [onMouseFocus, setOnMouseFocus] = useState(false);

    const { selectedProfile, ottSettings } = useSelector((state) => state.application);
    console.log(ottSettings);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        focusSelf();
    }, [focusSelf]);

    useEffect(() => {
        if (hasFocusedChild) {
            window.addEventListener('keydown', onKeyPress);
        } else {
            window.removeEventListener('keydown', onKeyPress)
        }

        return () => {
            window.removeEventListener('keydown', onKeyPress);;
        }

    }, [hasFocusedChild]);

    const onKeyPress = useCallback(async ({ keyCode }) => {
        if (keyCode === PLAYER.ENTER) {
            let user = utility.getValue(LOCAL_STORAGE_KEY.user);
            if (selectedMenu.current._id == "profile") {
                handleProfileSelect();
                return;
            }
            if (selectedMenu.current._id == "myDevices") {
                if (!user) {
                    navigate('/login');
                    return;
                }
                navigate('/removeDevice', { state: { user: user, fromLogin: false } });
                return;
            }
            if (selectedMenu.current._id == "logout" || selectedMenu.current._id == "login") {
                if (selectedMenu.current._id == "logout") {
                    try {
                        let ipaddressRes = await fetch('https://api.ipify.org?format=json');
                        let ipaddress = await ipaddressRes.json().then((data) => data['ip']);
                        let res = await removeDevice(user._id, ipaddress);
                        utility.setValue(LOCAL_STORAGE_KEY.user, null);
                        dispatch(setUser(null));
                        utility.clearLocalStorage();
                        dispatch(resetApplication());
                        navigate('/login');
                        console.log(res.message);
                        return;
                    } catch (error) {
                        console.log("error while logout ", error.message);
                    }
                } else {
                    utility.deleteValue(LOCAL_STORAGE_KEY.user);
                    dispatch(setUser(null));
                    navigate('/login');
                    return;
                }
            }
            if (selectedMenu.current._id == "Settings") {
                navigate("Settings");
                return;
            }
            if (selectedMenu.current._id == "search") {
                navigate('search');
                return;
            }
            // if (selectedMenu.current._id == "epg") {
            //     setCurrentPage(selectedMenu.current);
            //     return;
            // }
            let res = await getPage(selectedMenu.current._id);
            if (res.success) {
                setCurrentPage(res.data);
            } else {
                console.log("Page not found");
            }

        }

    });

    const onClick = () => {
        onKeyPress({ keyCode: PLAYER.ENTER });
    }

    const handleProfileSelect = () => {
        dispatch(setPrevPath(window.location.hash.replace(/^#/, '') ?? "/tv"));
        navigate('/profile');
    };

    return (
        <FocusContext.Provider value={focusKey}>
            <div style={{ width: "50px", position: "relative", overflow: "visible", zIndex: 1000, transition: "all 0.23s ease-in-out" }}>
                <div
                    onMouseEnter={() => setOnMouseFocus(true)}
                    onMouseLeave={() => setOnMouseFocus(false)}
                    style={{
                        flex: 1,

                        marginLeft: "10px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        backgroundColor: "rgba(0,0,0,0.5)",

                        overflow: "scroll",
                        transition: "all 0.23s ease-in-out",

                    }} ref={ref} hasFocusedChild={hasFocusedChild}>



                    <div style={{ backgroundColor: "rgba(0,0,0,0.8)", position: "fixed", overflow: "scroll", height: "100vh", marginLeft: hasFocusedChild || onMouseFocus ? "120px" : "0px", transition: "all 0.23s ease-in-out" }}>

                        <div style={{ height: "100px" }}>
                            {(hasFocusedChild || onMouseFocus) && <NmLogo src={ottSettings?.logo ?? ""} width={ottSettings?.logoSize ?? 25} showCrown={
                                utility.getValue(LOCAL_STORAGE_KEY.user)?.PaymentPlan?.length > 0 ? true : false ?? false
                            } />}
                            {(!ottSettings?.disableProfileSelection && selectedProfile) && <Smiley size="50px" profile={selectedProfile} margin="0px 0px 25px 0px" showName={(hasFocusedChild || onMouseFocus)} onClick={handleProfileSelect} onFocus={() => {
                                selectedMenu.current = { _id: "profile", displayName: "Profile", IconUrl: "Profile" };
                            }} />}
                            {/* Welcome Guest */}
                            {!selectedProfile && (hasFocusedChild || onMouseFocus) &&
                                <p style={{ color: "white", fontSize: "15px", marginTop: "25px", marginBottom: "25px", textAlign: "center" }}>{isLoginRef.current ? "Welcome " + utility.getValue(LOCAL_STORAGE_KEY.user)?.Name ?? "" : "Welcome Guest"}</p>}
                        </div>
                        <div style={{ marginTop: "120px" }}> {/* search */}
                            <MenuItem key={menu.length + 1} onClick={onClick} onMouseFocus={onMouseFocus} hasFocusedChild={hasFocusedChild} menuSettings={ottSetting.themeData.menu} item={{ _id: "search", displayName: "Search", IconUrl: "search" }} index={menu.length} setSelectedMenu={setSelectedMenu} currentPage={currentPage} />
                            {/* menu itemes */}
                            {menu.map((item, index) => (
                                <MenuItem key={index} onClick={onClick} onMouseFocus={onMouseFocus} hasFocusedChild={hasFocusedChild} menuSettings={ottSetting.themeData.menu} item={item} index={index} setSelectedMenu={setSelectedMenu} currentPage={currentPage} />
                            ))}
                            {/* <MenuItem key={menu.length + 3} onMouseFocus={onMouseFocus} hasFocusedChild={hasFocusedChild} menuSettings={ottSetting.themeData.menu} item={{ _id: "epg", displayName: "EPG", IconUrl: "tv" }} index={menu.length + 1} setSelectedMenu={setSelectedMenu} currentPage={currentPage} /> */}

                            {/* My Devices */}
                            {isLoginRef.current && <MenuItem key={menu.length + 2} onClick={onClick} onMouseFocus={onMouseFocus} hasFocusedChild={hasFocusedChild} menuSettings={ottSetting.themeData.menu} item={{ _id: "myDevices", displayName: "My Devices", IconUrl: "devices" }} index={menu.length + 1} setSelectedMenu={setSelectedMenu} currentPage={currentPage} />}

                            <MenuItem key={menu.length + 3} onClick={onClick} onMouseFocus={onMouseFocus} hasFocusedChild={hasFocusedChild} menuSettings={ottSetting.themeData.menu} item={{ _id: "Settings", displayName: "Settings", IconUrl: <i className="fa fa-gear" /> }} index={menu.length + 3} setSelectedMenu={setSelectedMenu} currentPage={currentPage} />

                            <MenuItem key={menu.length + 4} onClick={onClick} onMouseFocus={onMouseFocus} hasFocusedChild={hasFocusedChild} menuSettings={ottSetting.themeData.menu} item={{ _id: isLoginRef.current ? "logout" : "login", displayName: isLoginRef.current ? "Logout" : "Login", IconUrl: isLoginRef.current ? "logout" : "login" }} index={menu.length + 4} setSelectedMenu={setSelectedMenu} currentPage={currentPage} />
                            {/* epg*/}
                        </div>
                    </div>
                </div>
            </div>
        </FocusContext.Provider >
    );
}